import contactService from '@/api/contact'
import { CONTACT } from '../types'

export default {
  namespaced: true,
  state: {
    contacts: []
  },
  mutations: {
    [CONTACT.SET_CONTACT] (state, contacts) {
      state.contacts = contacts
    }
  },
  actions: {
    getContacts: function ({dispatch, commit}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        contactService.getContacts().then((response) => {
          commit(CONTACT.SET_CONTACT, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(()=>{
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    addContact: function ({state, dispatch}, contact) {
      let newContacts = [...state.contacts]
      newContacts.push(contact)
      return dispatch('saveContact', newContacts)
    },
    removeContact: function ({state, dispatch}, contact) {
      dispatch('Global/showLoading', null, {root: true})
      let newContacts = [...state.contacts]
      newContacts = newContacts.filter((item) => {
        return item !== contact
      })
      return dispatch('saveContact', newContacts)
    },
    saveContact: function ({ dispatch }, contacts) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        contactService.saveContacts(contacts).then(() => {
          dispatch('getContacts')
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    sendEmail: function ({dispatch, rootGetters}, message) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) =>{
        let data = {
          message: message,
          email: rootGetters['Auth/userEmail'],
          name: rootGetters['Auth/userName']
        }
        contactService.sendEmail(data).then(() =>{
          dispatch('Global/showMessage', 'msgSentSuccess', {root: true})
          resolve()
        }).finally(()=>{
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    }
  }
}
